"use strict";

var _defineProperty = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ldflexComunica = _interopRequireDefault(require("ldflex-comunica"));

var _solidAuthClient = _interopRequireDefault(require("solid-auth-client"));

var _util = require("./util");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * An extension of ComunicaEngine that delegates
 * SPARQL UPDATE queries directly to the documents
 * using authenticated request.
 */


var ComunicaUpdateEngine =
/*#__PURE__*/
function (_ldflexComunica$defau) {
  _inherits(ComunicaUpdateEngine, _ldflexComunica$defau);

  function ComunicaUpdateEngine() {
    _classCallCheck(this, ComunicaUpdateEngine);

    return _possibleConstructorReturn(this, _getPrototypeOf(ComunicaUpdateEngine).apply(this, arguments));
  }

  _createClass(ComunicaUpdateEngine, [{
    key: "executeUpdate",

    /**
     * Executes a SPARQL UPDATE query on the source.
     */
    value: function executeUpdate(sparql, source) {
      var _this = this;

      var done = false;

      var next =
      /*#__PURE__*/
      function () {
        var _ref = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee() {
          var sources, _sources, document, _ref2, ok, status, statusText;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!done) {
                    _context.next = 2;
                    break;
                  }

                  return _context.abrupt("return", {
                    done: done
                  });

                case 2:
                  done = true; // Find the document to update

                  _context.next = 5;
                  return source ? _this.toComunicaSources(source) : _this._sources;

                case 5:
                  sources = _context.sent;

                  if (!(!sources || sources.length !== 1)) {
                    _context.next = 8;
                    break;
                  }

                  throw new Error('Can only update a single source.');

                case 8:
                  _sources = _slicedToArray(sources, 1), document = _sources[0].value;

                  if (/^https?:\/\//.test(document)) {
                    _context.next = 11;
                    break;
                  }

                  throw new Error('Can only update an HTTP(s) document.');

                case 11:
                  _context.next = 13;
                  return _solidAuthClient.default.fetch(document, {
                    method: 'PATCH',
                    headers: {
                      'Content-Type': 'application/sparql-update'
                    },
                    body: sparql
                  });

                case 13:
                  _ref2 = _context.sent;
                  ok = _ref2.ok;
                  status = _ref2.status;
                  statusText = _ref2.statusText;

                  if (ok) {
                    _context.next = 19;
                    break;
                  }

                  throw new Error("Update query failed (".concat(status, "): ").concat(statusText));

                case 19:
                  _context.next = 21;
                  return _this.clearCache(document);

                case 21:
                  return _context.abrupt("return", {
                    value: (0, _util.createBindings)({
                      ok: ok
                    })
                  });

                case 22:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function next() {
          return _ref.apply(this, arguments);
        };
      }();

      return _defineProperty({
        next: next
      }, Symbol.asyncIterator, function () {
        return this;
      });
    }
    /**
     * Removes the given document (or all, if not specified) from the query engine cache,
     * such that fresh results are obtained the next time.
     */

  }, {
    key: "clearCache",
    value: function () {
      var _clearCache = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(document) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this._engine.invalidateHttpCache(document);

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function clearCache(_x) {
        return _clearCache.apply(this, arguments);
      }

      return clearCache;
    }()
  }]);

  return ComunicaUpdateEngine;
}(_ldflexComunica.default);

exports.default = ComunicaUpdateEngine;